import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { useDispatch } from "react-redux";
import { sendOtpApi, verifyOtpApi } from "utils/authThunk";
import toast from "react-hot-toast";

const Otp = () => {
  const navigate = useNavigate();
  const route = all_routes;
  const dispatch = useDispatch();
  const [otp, setOtp] = useState(["", "", "", ""]);
  const inputRefs = useRef([]);
  const [timer, setTimer] = useState(600); // 10 minutes = 600 seconds
  const [canResend, setCanResend] = useState(false);

  // Timer countdown
  useEffect(() => {
    if (timer > 0) {
      const countdown = setInterval(() => setTimer((prev) => prev - 1), 1000);
      return () => clearInterval(countdown);
    } else {
      setCanResend(true);
    }
  }, [timer]);

  const formatTime = () => {
    const minutes = String(Math.floor(timer / 60)).padStart(2, "0");
    const seconds = String(timer % 60).padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  const handleOtpChange = (value, index) => {
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 3) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    const enteredOtp = otp.join("");
    if (enteredOtp.length === 4) {
      // TODO: Add actual OTP verification logic here
      const result = await dispatch(
        verifyOtpApi({
          email: localStorage.getItem("email"),
          currentOtp: enteredOtp,
        })
      );
      if (result?.payload?.success) {
        toast.success(result?.payload?.message || "Otp verified successfully");
        localStorage.setItem("currentOtp", enteredOtp);
        navigate(route.setpassowrd);
      } else {
        toast.error(result?.payload || "Otp expired !");
      }
    } else {
      toast.error("Please enter the complete 4-digit OTP.");
    }
  };

  const handleResendOtp = async () => {
    if (canResend) {
      let result = await dispatch(sendOtpApi({ email:localStorage.getItem("email")})); // ✅ Use .unwrap()
      console.log("message: ", result);
      if (result?.payload?.success === false) {
        // setResponseMessage(false);
        toast.error(result?.payload);
        return;
      } else {
        toast.success(result?.payload?.message);
        // setResponseMessage(true);
        
        setTimer(600);
        setCanResend(false);
        setTimeout(() => {
          const Path = route.otp;
          navigate(Path);
        }, 1000);
      }
      // TODO: Resend OTP API logic here
    }
  };

  return (
    <>
      <div className="main-wrapper">
        <div className="login-content">
          <div className="row">
            <div className="col-md-6 login-bg d-none d-lg-flex">
              <div className="">
                <div className="login-carousel-section mb-3">
                  <div className="login-banner">
                    <ImageWithBasePath
                      src="assets/img/auth/auth-1.svg"
                      className="img-fluid"
                      alt="Logo"
                    />
                  </div>
                  <div className="mentor-course text-center">
                    <h3 className="mb-2">
                      Welcome to 
                      {" "}<span className="text-secondary">
                       AIATI in India.
                      </span>{" "}
                    </h3>
                    <p>
                      A trusted platform to manage, deliver, and track aviation learning .
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 login-wrap-bg">
              <div className="login-wrapper">
                <div className="loginbox">
                  <div className="w-100">
                    <div className="d-flex align-items-center justify-content-between login-header">
                      <img
                        src="/assets/img/logo/AviationLogo-08.png"
                        alt="Logo"
                        height="70"
                        style={{ height: "70px" }}
                      />
                      <Link to="/admin/login" className="link-1">
                        Back to Login
                      </Link>
                    </div>
                    <div className="topic">
                      <h1 className="fs-32 fw-bold mb-3">Email OTP</h1>
                      <p className="fs-14 fw-normal mb-0">
                        OTP sent to your Email Address ending ******
                        {localStorage.getItem("email")}
                      </p>
                    </div>

                    <form className="mb-3 pb-3" onSubmit={handleVerifyOtp}>
                      <div className="d-flex justify-content-center align-items-center mb-3">
                        {[0, 1, 2, 3].map((_, index) => (
                          <input
                            key={index}
                            ref={(el) => (inputRefs.current[index] = el)}
                            type="text"
                            style={{ height: "50px", width: "50px" }}
                            className="ms-3 text-center text-lg border border-gray-300 rounded"
                            maxLength={1}
                            placeholder="-"
                            value={otp[index]}
                            onChange={(e) =>
                              handleOtpChange(e.target.value, index)
                            }
                          />
                        ))}
                      </div>

                      <div className="timer-cover d-flex align-items-center justify-content-center">
                        <div className="badge badge-soft-danger rounded-pill d-flex align-items-center">
                          <i className="isax isax-clock me-1" />
                          <span id="otp_timer">{formatTime()}</span>
                          <span className="ms-1">s</span>
                        </div>
                      </div>

                      <div className="d-grid mt-3">
                        <button
                          className="btn btn-secondary btn-lg"
                          type="submit"
                          disabled={!canResend && timer === 0}
                        >
                          Verify &amp; Proceed
                          <i className="isax isax-arrow-right-3 ms-1" />
                        </button>
                      </div>
                    </form>

                    <div className="fs-14 fw-normal d-flex align-items-center justify-content-center">
                      Didn’t get the OTP?
                      <button
                        type="button"
                        className="btn btn-link link-2 ms-1 p-0"
                        onClick={handleResendOtp}
                        disabled={!canResend}
                      >
                        Resend OTP
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Otp;
